export const APPLICATION_DATA_REQUESTING = 'APPLICATION_DATA_REQUESTING';
export const APPLICATION_DATA_SUCCESS = 'APPLICATION_DATA_SUCCESS';
export const APPLICATION_DATA_ERROR = 'APPLICATION_DATA_ERROR';


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/store/application/constants.ts